/* eslint-disable import/no-anonymous-default-export */
import React, { useContext, useCallback } from 'react';
import { AjaxContext, formatListData } from 'commons-ui';
import { ISegmentConfigData } from './type';
import { CREATE_CONFIG_URI, DISABLE_CONFIG_URI, GET_CONFIG_URI, UPDATE_CONFIG_URI } from '../../gstHelper';

const useService = () => {
	const [isActive, setIsActive] = React.useState<{ id: boolean; label: string }>({ id: true, label: 'TEST' });
	const [gstOfferSegmentsData, setGstOfferSegmentsData] = React.useState<{ id: string; label: string }[]>([
		{ id: '0', label: 'HELLO' }
	]);
	const { postData } = useContext(AjaxContext);
	const getGSTConfigData = useCallback(
		async ({
			app,
			pageDetails,
			sortDetails,
			filterDetails
		}: {
			app: any;
			pageDetails: any;
			sortDetails: any;
			filterDetails: any;
		}) => {
			const { isGold, appName } = app;
			const response = await postData({
				endpoint: GET_CONFIG_URI,
				body: {
					page: pageDetails,
					filters: filterDetails,
					sortInfoArray: sortDetails,
					isGold
				},
				queryParams: {
					appName
				}
			});
			const listData = formatListData(response?.data?.data?.gstSegmentConfig);
			const gstOfferSegments = response?.data?.data?.gstOfferSegments;
			const segmentList: { id: string; label: string }[] = [];
			gstOfferSegments.forEach((segment: string) => segmentList.push({ id: segment, label: segment }));
			setGstOfferSegmentsData(segmentList);
			const count = response?.data?.data.length;
			return { rowCount: count, data: listData };
		},
		[]
	);

	const requestCreateConfig = useCallback((appName: string, data: ISegmentConfigData) => {
		const dataList = [];
		dataList.push(data);
		return postData({
			endpoint: CREATE_CONFIG_URI,
			body: { gstConfigs: data },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestUpdateConfig = useCallback((appName: string, data: ISegmentConfigData) => {
		return postData({
			endpoint: UPDATE_CONFIG_URI,
			body: { gstConfigs: data },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestDisableConfig = useCallback((appName: string, data: ISegmentConfigData) => {
		return postData({
			endpoint: DISABLE_CONFIG_URI,
			body: { segmentName: data.segmentName },
			queryParams: {
				appName
			}
		});
	}, []);

	const toggleIsDisabledField = useCallback(async (rowData: any, history: any, user: any, app: any, showAlert: any) => {
		const data = rowData;
		try {
			const response = await requestDisableConfig(app.appName, { ...data });
			if (response?.status !== 200 || !response?.data?.success) {
				showAlert(response?.data?.error || 'Error occured while disabling', { type: 'error' });
				return;
			}
			showAlert('Config removed from the app');
		} catch (error: any) {
			data.isDisabled = !data.isDisabled;
			showAlert(error?.response?.data?.error || 'Error occured while removing', { type: 'error' });
		}
	}, []);
	return {
		getGSTConfigData,
		gstOfferSegmentsData,
		requestUpdateConfig,
		requestCreateConfig,
		toggleIsDisabledField,
		isActive,
		setIsActive
	};
};

export default useService;
